import { Injectable } from "@nestjs/common";
import { DataSource, Repository } from "typeorm";
import { StocksEntity } from "../stocks.entity";
import { InjectRepository } from "@nestjs/typeorm";
import { CommonResponseModel, StockFilterRequest, StocksDto, buyerandM3ItemIdReq } from "@project-management-system/shared-models";

@Injectable()
export class StocksRepository extends Repository<StocksEntity> {
    constructor(@InjectRepository(StocksEntity) private userRepository: Repository<StocksEntity>,
    private readonly dataSource: DataSource,

    ) {
        super(userRepository.target, userRepository.manager, userRepository.queryRunner);
    }

    async getAllItemCode(): Promise<any> {
        const query = await this.createQueryBuilder('stocks')
            .select(`stocks.m3_item_code as m3ItemCode`)
            .where(`stocks.m3_item_code is not null`)
            .orderBy(`stocks.m3_item_code`)
            const data=await query.getRawMany()
        return data;
    }

    async getAllItemType(): Promise<any> {
        const query = await this.createQueryBuilder('stocks')
            .select(`stocks.item_type as itemtype`)
            .where(`stocks.item_type is not null`)
            .orderBy(`stocks.item_type`)
            const data=await query.getRawMany()
        return data;
    }

    async getAllLocation(): Promise<any> {
        const query = await this.createQueryBuilder('s')
            .select(`r.rack_position_name AS location,s.location_id`)
            .leftJoin('rack_position', 'r', 'r.position_Id = s.location_id')
            .where(`r.rack_position_name is not null`)
            .orderBy(`r.rack_position_name`)
            .groupBy('r.rack_position_name')
    
        const data = await query.getRawMany();
        return data;
    }
    
    async getAllPlant(): Promise<any> {
        const query = await this.createQueryBuilder('stocks')
            .select(`stocks.plant_id as plant_id`)
            .where(`stocks.plant_id is not null`)
            .orderBy(`stocks.plant_id`)
            const data=await query.getRawMany()
        return data;
    }

    async getAllStockReportData(req: StockFilterRequest) {
        // console.log("Repo........................................................");
        
        let query = this.createQueryBuilder('stocks')
            .select(`b.buyer_name AS buyerName, 
            m3_item_code AS m3ItemCode,item_type_id AS itemType,
            location_id AS location, plant_id AS plant
             left join buyers b on b.buyer_id = stocks.buyer_id
            left join m3_items it on it.buyer_id = stocks.buyer_id
            `)

        if (req.m3ItemCode !== undefined) {
            query.andWhere(`m3_item_code ='${req.m3ItemCode}'`)
        }
        if (req.itemType !== undefined) {
            query.andWhere(`item_type_id ='${req.itemType}'`)
        }
        if (req.location !== undefined) {
            query.andWhere(`location_id ='${req.location}'`)
        }
        if (req.plant !== undefined) {
            query.andWhere(`plant_id ='${req.plant}'`)
        }
      

        return await query.getRawMany();

    }
    async getAvailbelQuantityAginstBuyerAnditem(req: buyerandM3ItemIdReq): Promise<CommonResponseModel> {
        try {
        //   console.log("getAvailbelQuantityAginstBuyerAnditem")
          const manager = this.dataSource;
          //  const query='SELECT st.quantity-IF(st.issued_quantity IS NOT NULL,st.issued_quantity,0) AS totalAvailablequntity, mai.allocate_quantity AS materialAlloctedquantity,st.allocatd_quantity AS stocpurchae_order_itemskAllocatedQty,st.quantity AS stockQuantity,(st.quantity-st.allocatd_quantity) AS resultAvailableQuantity,st.item_type AS itemType,g.grn_number AS grnNumber,r.rack_position_name,st.id AS stockId,st.m3_item AS m3ItemId,st.buyer_id AS buyerId,st.item_type AS itemType, st.location_id AS locationId, st.quantity,st.grn_item_id AS grnItemId,stock_bar_code AS stockBarCode, FALSE AS checkedStatus,date(g.grn_date) as grnDate FROM stocks st LEFT JOIN rack_position r ON r.position_Id=st.location_id LEFT JOIN grn_items gi ON gi.grn_item_id=st.grn_item_id LEFT JOIN grn g ON g.grn_id=gi.grn_id LEFT JOIN material_allocation_items mai ON mai.stock_id=st.id WHERE st.buyer_id='+req.buyerId+' AND st.m3_item= '+req.m3ItemId+'  AND st.item_type="'+req.itemType+'" AND (st.quantity-IF(st.issued_quantity IS NOT NULL,st.issued_quantity,0)) >0 order by g.grn_date'
    
          const rawQuery = 'Select 0 AS issuedQty,st.buyer_id AS buyerId,st.location_id AS locationId,st.m3_item AS m3ItemId,st.item_type AS itemType,st.grn_item_id AS grnItemId, st.id AS stockId,(quantity-allocatd_quantity-transfered_quantity) AS quantity, g.grn_number AS grnNumber, date(g.grn_date) as grnDate, rp.rack_position_name AS location, FALSE AS checkedStatus, stock_bar_code AS stockBarCode,fc.colour AS color from stocks st left join grn_items gi on gi.grn_item_id = st.grn_item_id left join rack_position rp on rp.position_id = st.location_id left join grn g on g.grn_id = gi.grn_id left join purchae_order_items poi ON poi.purchase_order_item_id = gi.po_item_id left join colour fc ON fc.colour_id = poi.colour_id where id>0 and st.grn_type = "INDENT" and st.buyer_id=' + req.buyerId + ' AND st.m3_item= ' + req.m3ItemsId + ' AND st.item_type="' + req.itemType + '" and (quantity-allocatd_quantity-transfered_quantity) > 0';
          // const queryy ='SELECT mai.allocate_quantity AS materialAlloctedquantity,st.allocatd_quantity AS stockAllocatedQty,st.quantity AS stockQuantity,(st.quantity-st.allocatd_quantity) AS resultAvailableQuantity,st.item_type AS itemType,g.grn_number AS grnNumber,r.rack_position_name,st.id AS stockId,st.m3_item AS m3ItemId,st.buyer_id AS buyerId,st.item_type AS itemType, st.location_id AS locationId,st.quantity,st.grn_item_id AS grnItemId,stock_bar_code AS stockBarCode, false AS checkedStatus FROM stocks st LEFT JOIN rack_position r ON r.position_Id=st.location_id LEFT JOIN grn_items gi ON gi.grn_item_id=st.grn_item_id LEFT JOIN grn g ON g.grn_id=gi.grn_id  LEFT JOIN material_allocation_items mai ON mai.stock_id=st.id WHERE st.buyer_id='+req.buyerId+' AND st.m3_item= '+req.m3ItemId+' and st.item_type="'+req.itemType+'" AND (st.quantity-st.allocatd_quantity)>0'
        //   console.log(rawQuery)
    
          const rmData = await manager.query(rawQuery);
        //   console.log(rmData)
          if (rmData) {
            return new CommonResponseModel(true, 1, 'data', rmData)
          } else {
            return new CommonResponseModel(false, 0, 'no data', [])
    
          }
    
        } catch (err) {
          throw err
        }
      }


}